module.exports = __webpack_public_path__ + "static/how-to-2-554ba4558980e70ada7087827afbe829.webp";